/**
 * Bootstrap del portale acquisti.
 *
 * MSAL non e' riconfigurato: `@shared/config/authConfig` usa `redirectUri: window.location.origin`,
 * quindi lo stesso file funziona su `manutenzioni.peralbahc.com` e su `acquisti.peralbahc.com`
 * appena il secondo e' registrato come redirect URI sull'app registration `84a58755-…`. Stesso
 * tenant, stesso client id, nessuna identita' nuova da gestire.
 */

import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { MsalProvider } from "@azure/msal-react";
import { PublicClientApplication } from "@azure/msal-browser";
import { AuthProvider } from "@shared/context/AuthContext";
import { ToastProvider } from "@shared/components/ui/Toast";
import { msalConfig } from "@shared/config/authConfig";
import App from "./App";
import "./index.css";

const msalInstance = new PublicClientApplication(msalConfig);

const renderApp = () => {
  ReactDOM.createRoot(document.getElementById("root")).render(
    <React.StrictMode>
      <BrowserRouter>
        <MsalProvider instance={msalInstance}>
          <AuthProvider>
            <ToastProvider>
              <App />
            </ToastProvider>
          </AuthProvider>
        </MsalProvider>
      </BrowserRouter>
    </React.StrictMode>,
  );
};

// Stesso schema del portale manutenzioni: si rende comunque dopo 10 secondi, cosi' un problema
// di inizializzazione MSAL da' una pagina di login e non una pagina bianca.
let rendered = false;
const safeRender = () => {
  if (!rendered) {
    rendered = true;
    renderApp();
  }
};

const timeoutId = setTimeout(() => {
  console.warn("MSAL initialization timeout - rendering anyway");
  safeRender();
}, 10000);

msalInstance
  .initialize()
  .then(() => msalInstance.handleRedirectPromise())
  .then((response) => {
    clearTimeout(timeoutId);
    if (response) {
      console.log("Login redirect handled", response.account?.username);
    }
    safeRender();
  })
  .catch((error) => {
    clearTimeout(timeoutId);
    console.error("MSAL initialization or redirect handling failed:", error);
    safeRender();
  });
